import { render, staticRenderFns } from "./PayScale.vue?vue&type=template&id=98605f86&scoped=true"
import script from "./PayScale.vue?vue&type=script&lang=js"
export * from "./PayScale.vue?vue&type=script&lang=js"
import style0 from "./PayScale.vue?vue&type=style&index=0&id=98605f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98605f86",
  null
  
)

export default component.exports